<footer class="it-footer">
  <div class="it-footer-small-prints clearfix">
    <div class="container">
      <ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
        <li class="list-inline-item"><a href="/informativa-privacy" title="Informativa-Privacy">Informativa Privacy</a>
        </li>
        <li class="list-inline-item"><a target="_blank" href="https://www.invitalia.it/privacy-policy"
            title="Policy-Privacy">Policy Privacy</a></li>
        <li class="list-inline-item"><a target="_blank"
            href="https://www.invitalia.it/-/media/invitalia/documenti/trasparenza/codice-etico-e-modello-organizzativo/codice-etico-invitalia-2023.pdf"
            title="Codice-Etico">Codice Etico</a></li>
        <li class="list-inline-item"><a [href]="urlRegolamento" title="Regolamento-Piattaforma">Regolamento
            Piattaforma</a></li>
        <!-- <li class="list-inline-item"><a href="#" title="Cookie-Policy">Cookie Policy</a></li> -->
      </ul>
    </div>
  </div>
</footer>
